const PassengersRoutes = {
  getPassengers: "/companies/passengers",

};

export default PassengersRoutes